import useToastStore, { ToastType } from "@/store/toastStore";

const TYPE_STYLE: Record<ToastType, string> = {
  error: "bg-red-500",
  success: "bg-green-600",
  info: "bg-gray-800",
};

const Toast = () => {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-[100] flex w-full max-w-sm -translate-x-1/2 flex-col gap-2 px-4">
      {toasts.map(toast => (
        <div
          key={toast.id}
          role="alert"
          className={`${TYPE_STYLE[toast.type]} cursor-pointer rounded-lg px-4 py-3 text-sm text-white shadow-lg`}
          onClick={() => removeToast(toast.id)}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};

export default Toast;
